module.exports = __webpack_public_path__ + "img/rspca-vic.a3a8de4.png";